// action - state management
import * as actionTypes from '../actionTypes'
import { updateObject } from '../shared/utility'

interface actionType {
  type: string
  payload: any
}

export const initialState = {
    campaignFlags:{
        is_balance_change: false
    }
}

// ==============================|| CAMPAIGN FLAGS REDUCER ||============================== //

const campaignFlagsReducer = (state = initialState, action: actionType) => {
  switch (action.type) {
    case actionTypes.IS_BALANCE_CHANGE:
  return updateObject(state, {
    campaignFlags: {
      ...state.campaignFlags,
      is_balance_change: action.payload 
    }
  })

    default:
      return state
  }
}

export default campaignFlagsReducer
